<template>
  <!-- 二维地图功能面板 -->
  <div class="meteorologyPanel">
    <div class="openMeteo" v-show="!open" @click="open = true">
      <img src="../../assets/img/2dmap/close.png" alt="" />
    </div>
    <div class="contentAll" v-show="open">
      <div class="closeMeteo" @click="open = false">
        <img src="../../assets/img/2dmap/open.png" alt="" />
      </div>
      <div class="meteoTitle"><span>气象管理</span></div>
      <div class="meteoIcons">
        <div
          class="iconItem"
          :class="active == index + 1 ? 'active' : ''"
          @click="handelMeteo(index + 1)"
          v-for="(item, index) in meteoList"
          :key="index"
        >
          <span>{{ item }}</span>
        </div>
      </div>
      <div style="height: calc(100% - 180px);overflow-y:auto;display:none">
        <div class="task-content">
          <div class="task-item">
            <div class="task-title"><span>执行中</span></div>
            <div class="listAll" v-if="runTask.length !== 0">
              <div class="task-list">
                <div
                  class="task"
                  v-for="item in runTask"
                  :key="item.id"
                  @click="positPlane(item)"
                >
                  <span class="firstSpan">{{ item.planSerial }}</span>
                  <span class="secondSpan">{{ item.pilot }}</span>
                  <span class="thirdSpan">{{ item.type }}</span>
                </div>
              </div>
            </div>
            <div class="empty" v-if="runTask.length == 0">
              <span>暂无数据</span>
            </div>
          </div>
          <div class="task-item">
            <div class="task-title"><span>待执行</span></div>
            <div class="listAll" v-if="preTask.length !== 0">
              <div class="task-list">
                <div
                  class="task"
                  v-for="item in preTask"
                  :key="item.id"
                  @click="positWay(item)"
                >
                  <span class="firstSpan">{{ item.planSerial }}</span>
                  <span class="secondSpan">{{ item.pilot }}</span>
                  <span class="thirdSpan">{{ item.type }}</span>
                </div>
              </div>
            </div>
            <div class="empty" v-if="preTask.length == 0">
              <span>暂无数据</span>
            </div>
          </div>
          <div class="task-item">
            <div class="task-title"><span>实时事件</span></div>
            <div class="listAll" v-if="realTask.length !== 0">
              <div class="task-list">
                <div
                  class="task"
                  :class="item.warning ? 'warn' : 'alarm'"
                  v-for="item in realTask"
                >
                  <span class="firstSpan">{{ item.warnMes }}</span>
                </div>
              </div>
            </div>
            <div class="empty" v-if="realTask.length == 0">
              <span>暂无数据</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //父组件传递的数据
    runTask: {
      type: Array,
      default: []
    },
    infoArr: {
      type: Array,
      default: []
    },
    preTask: {
      type: Array,
      default: []
    },
    realTask: {
      type: Array,
      default: []
    },
    // 接收父组件传递的方法
    planeWay: {
      type: Function,
      default: null
    },
    showSign: {
      type: Function,
      default: null
    },
    deleteShowSign: {
      type: Function,
      default: null
    },
    planeAllWay: {
      type: Function,
      default: null
    },
    deletePlaneAllWay: {
      type: Function,
      default: null
    },

    airSpace: {
      type: Function,
      default: null
    },
    daleteAirSpace: {
      type: Function,
      default: null
    },
    airPort: {
      type: Function,
      default: null
    },
    daleteAirPort: {
      type: Function,
      default: null
    },
    positionPoint: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      meteoList: ["温度", "湿度", "降水", "压强", "风速", "风向"],
      active: 0,
      open: false
    };
  },
  mounted() {},
  methods: {
    handelMeteo(index) {
      this.active = index;
      this.$emit("changeMeteo", this.active);
    },
    callplayWay() {
      this.active1 = !this.active1;
      // if (this.active1) {
      //   this.addPolyAllline();
      // } else {
      //   this.deletePolyAllline();
      // }
      this.$emit("messageFromChild", this.active1);
    },
    callShowSign() {
      this.active2 = !this.active2;
      if (this.active2) {
        this.showSign();
      } else {
        this.deleteShowSign();
      }
    },
    callPlanWay() {
      this.active3 = !this.active3;
      if (this.active3) {
        this.planeAllWay();
      } else {
        this.deletePlaneAllWay();
      }
    },
    callairSpace() {
      this.active4 = !this.active4;
      if (this.active4) {
        this.airSpace();
      } else {
        this.daleteAirSpace();
      }
    },
    callairport() {
      this.active5 = !this.active5;
      if (this.active5) {
        this.airPort();
      } else {
        this.daleteAirPort();
      }
    },
    positPlane(info) {
      if (this.infoArr.length > 0) {
        var foundObject = this.infoArr.find(function(item) {
          return item.id === info.planSerial;
        });
        let point = {
          longitude: foundObject.longtitude,
          latitude: foundObject.latitude
        };
        this.positionPoint(point);
      }
    },
    positWay(item) {
      //显示所有航线就定位，否则画出航线并定位
      if (!this.active3) {
        let airLineData = [];
        item.airpointList.forEach(airpoint => {
          airLineData.push([airpoint.latitude, airpoint.longitude]);
        });
        // rgba(181, 133 ,0,0.5)
        this.planeWay(airLineData, "rgba(14, 29, 192,0.5)", "position");
      }
      this.positionPoint(item.airpointList[0]);
    }
  }
};
</script>

<style scoped>
.meteorologyPanel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* overflow-y: auto; */
}
.openMeteo {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background: rgba(15, 86, 115, 0.4);
}
.openMeteo img {
  width: 16px;
  height: 16px;
  margin: 7px;
}
.contentAll {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 86, 115, 0.2);
}
.contentAll .closeMeteo {
  position: absolute;
  left: -30px;
  top: 0;
  width: 30px;
  height: 30px;
  background: rgba(15, 86, 115, 0.4);
}
.contentAll img {
  width: 16px;
  height: 16px;
  margin: 7px;
}
.meteoTitle {
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  line-height: 40px;
  text-align: left;
  background: rgba(2, 67, 133, 0.8);
}
.meteoTitle span {
  margin: 20px 0 0 13px;
  line-height: 38px;
}
.meteoIcons {
  margin: 20px 0;
}

.meteoIcons .iconItem {
  margin-bottom: 12px;
  margin-left: 35px;
  text-align: center;
  width: 80px;
  height: 50px;
  background-image: url("../../assets/img/2dmap/iconbac1.png");
  background-size: 100% 100%;
}
.meteoIcons .active span {
  color: #fee075 !important;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85) !important;
}
.meteoIcons .iconItem img {
  width: 34px;
  height: 32px;
  margin-left: 20px;
  vertical-align: middle;
  margin-right: 7px;
}
.meteoIcons .iconItem span {
  vertical-align: middle;
  font-family: Source Han Sans CN;
  font-size: 16px;
  color: #dff2ff;
  line-height: 50px;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85);
}
.task-content {
  height: 100%;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.task-content .task-item {
  padding-bottom: 8px;
  margin-bottom: 15px;
  background-image: url("../../assets/img/2dmap/bac1.png");
  background-size: 100% 100%;
}
.task-item .task-title {
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
  line-height: 30px;
  margin-top: 10px;
  /* line-height: 50px;
  margin-top: 16px; */
  text-align: left;
}
.task-item .task-title span {
  margin: 20px 0 0 13px;
  line-height: 38px;
}
.task-item .listAll {
  height: 138px;
  /* height: 200px; */
  overflow-y: auto;
}
.task-item .listAll .task-list {
  margin: 6px 11px 0 11px;
}
.task-item .task-list .task {
  width: 100%;
  height: 25px;
  margin-bottom: 3px;
  text-align: left;
  background: linear-gradient(
    90deg,
    rgba(0, 154, 192, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}
.task-item .task-list .warn {
  background: linear-gradient(
    90deg,
    rgba(255, 150, 0, 0.8),
    rgba(71, 160, 255, 0.2)
  );
}
.task-item .task-list .alarm {
  background: linear-gradient(
    90deg,
    rgba(218, 0, 1, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}
.task-item .task-list .task span {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  line-height: 25px;
}
.task-item .task-list .task .firstSpan {
  margin-left: 9px;
}
/* .task-item .task-list .task .secondSpan {
  margin-left: 3px;
}
.task-item .task-list .task .thirdSpan {
  margin-left: 2px;
} */
#map-container .leaflet-left {
  left: auto !important;
  top: auto !important;
  right: 28px !important;
  bottom: 60px !important;
}
#map-container .leaflet-left a {
  width: 45px;
  height: 45px;
  background-image: url("../../assets/img/2dmap/iconbac3.png");
}
.leaflet-bar {
  border: none !important;
}
.leaflet-bar a {
  background-color: transparent !important;
}
.leaflet-control-zoom-in {
  margin-bottom: 6px;
}
.leaflet-control-zoom-in span {
  line-height: 45px;
  color: #bfd9ff;
}
.leaflet-control-zoom-out span {
  line-height: 45px;
  color: #bfd9ff;
}
.empty {
  height: 126px;
  margin: 6px 11px 0 11px;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(0, 154, 192, 0.8),
    rgba(71, 160, 255, 0.11)
  );
}
.empty span {
  line-height: 120px;
  color: #fff;
  font-size: 14px;
}

/* @-webkit-keyframes */
@keyframes blinker {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}

.blinking {
  -webkit-animation-name: blinker;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
  -webkit-animation-duration: 1s;
  animation-name: blinker;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.5, 0, 1, 1);
  animation-duration: 1s;
}
</style>



// WEBPACK FOOTER //
// src/components/home/MeteorologyPanel.vue